var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"froalaViews"}},[(!_vm.value)?_c('el-empty',{attrs:{"description":"暂无内容"}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }